import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AutoFocusDirective } from './auto-focus.directive';
import { BusyIfDirective } from './busy-if.directive';
import { ButtonBusyDirective } from './button-busy.directive';
import { CurrencyInputDirective } from './currency-input.directive';
import { FileDownloadService } from './file-download.service';
import { FriendProfilePictureComponent } from './friend-profile-picture.component';
import { LocalStorageService } from './local-storage.service';
import { MomentFormatPipe } from './moment-format.pipe';
import { NormalizeDropdownPositionDirective } from './normalize-dropdown-position.directive';
import { ValidationMessagesComponent } from './validation-messages.component';
import { EqualValidator } from './validation/equal-validator.directive';
import { MinValueValidator } from './validation/min-value-validator.directive';
import { PasswordComplexityValidator } from './validation/password-complexity-validator.directive';
import { NullDefaultValueDirective } from './null-value.directive';
import { CodeInputDirective } from './code-input.directive';
import { NumbericOnlyDirective } from './numberic-only-directive';
import { NumberInputDirective } from './number-input.directive';
import { BlockWhiteSpacesDirective } from './block-whitespaces.directive';
import { NumberDirective } from './numbers-only.directive';
import { TranslatePipe } from '@app/main/report/pipes/translate.pipe';

@NgModule({
    imports: [
        CommonModule
    ],
    providers: [
        FileDownloadService,
        LocalStorageService,
        TranslatePipe
    ],
    declarations: [
        EqualValidator,
        PasswordComplexityValidator,
        MinValueValidator,
        ButtonBusyDirective,
        AutoFocusDirective,
        BusyIfDirective,
        FriendProfilePictureComponent,
        MomentFormatPipe,
        CurrencyInputDirective,
        NormalizeDropdownPositionDirective,
        ValidationMessagesComponent,
        NullDefaultValueDirective,
        CodeInputDirective,
        NumbericOnlyDirective,
        NumberInputDirective,
        BlockWhiteSpacesDirective,
        NumberDirective,
        TranslatePipe
    ],
    exports: [
        EqualValidator,
        PasswordComplexityValidator,
        MinValueValidator,
        ButtonBusyDirective,
        AutoFocusDirective,
        BusyIfDirective,
        FriendProfilePictureComponent,
        MomentFormatPipe,
        CurrencyInputDirective,
        NormalizeDropdownPositionDirective,
        ValidationMessagesComponent,
        NullDefaultValueDirective,
        CodeInputDirective,
        NumbericOnlyDirective,
        NumberInputDirective,
        BlockWhiteSpacesDirective,
        NumberDirective,
        TranslatePipe
    ]
})
export class UtilsModule { }
